import React from 'react';
import { Sidebar, Text } from 'bench-internal-theme';
import { WrappedSpinner } from 'spinner';
import { useClient } from '../../ClientContext';
import { GET_CONNECTIONS } from '../queries';
import { useQuery } from '@apollo/client';
import LedgerMappingSidebar from './LedgerMappingSidebar';
import { colors } from 'bench-style-constants';

type LedgerMappingSidebarContainerProps = {
  connectionId: string;
  closeSidebar: () => void;
};

const LedgerMappingSidebarContainer = ({
  connectionId,
  closeSidebar,
}: LedgerMappingSidebarContainerProps) => {
  const { id: clientId } = useClient();

  const { loading, error, data } = useQuery(GET_CONNECTIONS, {
    variables: { clientId },
  });

  if (loading) {
    return (
      <Sidebar headerContent="Edit" dismiss={closeSidebar}>
        <WrappedSpinner />
      </Sidebar>
    );
  }

  if (error) {
    return (
      <Sidebar headerContent="Edit" dismiss={closeSidebar}>
        <Text styleType="small" color={colors.cloud}>
          An error occurred fetching accounts for this connection.
        </Text>
      </Sidebar>
    );
  }

  const connections = data?.client?.financialConnections || [];
  const connection = connections.find(connection => connection.id === connectionId);

  return <LedgerMappingSidebar connection={connection} closeSidebar={closeSidebar} />;
};

export default LedgerMappingSidebarContainer;
